import type { ElementType } from "react";
import { ButtonIcon } from "./ButtonIcon";
import { BaseButton } from "./index";
import type { IButtonProps, IIconButtonProps } from "./types";

export const IconButton = <C extends ElementType = "button">(
  props: IIconButtonProps<C>,
) => {
  return (
    <BaseButton<C>
      {...(props as IButtonProps<C>)}
      startIcon={undefined}
      endIcon={undefined}
      spinnerPosition="center"
      isIcon={true}
      aria-label={props["aria-label"]}
    >
      <ButtonIcon
        size={props.size || "sm"}
        icon={props.children || props.content}
      />
    </BaseButton>
  );
};
